
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../../assets/css/EnquiryReport.css";

function IncomeReport() {
  const { id } = useParams();
  const [filtered, setFiltered] = useState([]);

  const [statuses, setStatuses] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [totalincome, settotalincome] = useState([])
  const [branch, setbranch] = useState([])
  const [Branches, setselectBranch] = useState([])
  const [loading, setLoading] = useState(false)

  const [totalamount, settotalamount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const leadsResponse = await axios.get(apiUrl + "/income_list");
        setFiltered(leadsResponse.data);

        console.log("The leadsResponse.data in the fetch data is : ", leadsResponse.data[0].branch_id.branch_name);

        // Fetch income types instead of statuses
        const incomeResponse = await axios.get(apiUrl + "/income_list");

        const totalIncome = await axios.get(apiUrl + "/income");
        settotalincome(totalIncome.data)


        const branchresponse = await axios.get(apiUrl + "/branch");
        console.log("Branch response:", branchresponse.data);


        if (Array.isArray(branchresponse.data)) {
          setbranch(branchresponse.data);
        } else {
          console.error("Unexpected data format:", branchresponse.data);
        }


        // Extract unique income types
        const uniqueTypes = Array.from(
          new Set(incomeResponse.data.map((item) => item.type))
        ).map((type) => ({ type }));

        setStatuses(uniqueTypes); // Store types in the statuses state
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setTimeout(
        () => {
          setLoading(false)
        }, 500
      )
    };

    fetchData();
  }, [id]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
    setCurrentPage(1);
  };

  const formatDatefitching = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  // ===================== code to convert the date ====================
  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };
  // =================== code to convert the date ======================

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const filteredData = filtered.filter((item) => {
    // Check if there's a type filter (selectedStatus)
    const isStatusMatch = selectedStatus
      ? item.type === selectedStatus
      : true;  // If no selectedStatus, match all


    // const isBranchMatch = Branches
    // ? item.branch_id === Branches
    // : true;

    const isBranchMatch = Branches
      ? item.branch_id.branch_name === Branches
      : true;

    // const isBranchMatch = Branches.length > 0
    //   ? Branches.some(branch => branch._id === item.branch_id) // Match against branch ID in the array
    //   : true;


    const itemEnquiryDate = new Date(item.date);
    const isFromDateMatch = fromDate
      ? itemEnquiryDate >= new Date(fromDate)
      : true;
    const isToDateMatch = toDate ? itemEnquiryDate <= new Date(toDate) : true;




    // If the status doesn't match, skip this item early  
    if (!isStatusMatch) return false;

    // // If searchTerm is provided, check if the item matches any of the search criteria
    // const isSearchMatch = searchTerm
    //   ? 
    //   (item.branch_id[0].branch_name &&
    //     item.branch_id[0].branch_name
    //       .toLowerCase()
    //       .includes(searchTerm.toLowerCase())) ||
    //   (item.type[0].type &&
    //     item.type[0].type.toLowerCase().includes(searchTerm.toLowerCase())) ||
    //   (item.date && String(item.date).includes(searchTerm)) ||
    //   (item.amount && String(item.amount).includes(searchTerm)) ||
    //   (item.paytype &&
    //     String(item.paytype.toLowerCase()).includes(searchTerm.toLowerCase())) ||
    //   (item.to && String(item.to).includes(searchTerm)) ||
    //   (item.branch_id?.toLowerCase().includes(searchTerm.toLowerCase())) ||
    //   (item.from && String(item.from).includes(searchTerm)) ||
    //   (item.description && String(item.description).includes(searchTerm))
    //   : true;  // If no search term, match everything

    // Handling search term filtering
    const isSearchMatch = searchTerm
      ? (item?.type &&
        item.type.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.branch_id?.branch_name &&
        item.branch_id?.branch_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.description &&
        item.description.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.person_name &&
        item.person_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.paid_by &&
        item.paid_by.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.paytype &&
        item.paytype.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item?.amount &&
        String(item.amount).toLowerCase().includes(searchTerm.toLowerCase()))
      : true;

    return isSearchMatch && isStatusMatch && isBranchMatch && isFromDateMatch && isToDateMatch;
  });


  const currentEntries = filteredData.slice(
    indexOfFirstEntry,
    indexOfLastEntry
  );


  // ============= code to set the dynamic total amount ===================
  // useEffect(() => {
  //   if(currentEntries && currentEntries.length>0)
  //   {
  //     console.log("the currentEntries in attendance report page is : ",currentEntries);
  //     sumTotalAmount();
  //   }
  // }, [currentEntries]);
  useEffect(() => {
    if (currentEntries && currentEntries.length > 0) {
      console.log("The currentEntries in attendance report page are:", currentEntries);
      sumTotalAmount(); // Sum the total amount if there are matching entries
    } else {
      // If no entries match the search, set totalAmount to 0
      settotalamount(0);
    }
  }, [currentEntries]);

  const sumTotalAmount = () => {
    const totalAmount = currentEntries.reduce((sum, item) => sum + item.amount, 0);
    // console.log("The totalAmount in the sumTotalAmount is : ",totalAmount);
    settotalamount(totalAmount);
  }
  // ============= code to set the dynamic total amount ===================


  const handleEntriesPerPageChange = (event) => {
    setEntriesPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setCurrentPage(1);
  };

  // const handleStatusChange = (event) => {
  //   setSelectedStatus(event.target.value);
  //   setCurrentPage(1);
  // };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // =========== code to fetch the data at initially ================
  useEffect(() => {
    handleClearFilters();
  }, []);
  // =========== code to fetch the data at initially ================

  const handleClearFilters = () => {
    setSelectedCourse("");
    setSelectedStatus("");
    setselectBranch("");
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handleCopy = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const tableData = tableElement.innerText;
      navigator.clipboard
        .writeText(tableData)
        .then(() => {
          alert("Income Table data copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };

  // This is the first code 
  // const handleCSVExport = () => {
  //   const csvHeaders = [
  //     "S.No",
  //     "branch",
  //     "Type",
  //     "Date",
  //     "Notes",
  //     "Amount",
  //     "From",
  //     "To",
  //     "Paytype",
  //   ];
  //   const csvData = filteredData.map((item, index) => [
  //     index + 1,
  //     item.branch_id,
  //     item.type,
  //     formatDatefitching(item.date),
  //     item.notes,
  //     item.amount,
  //     item.from,
  //     item.to,

  //     item.paytype,
  //   ]);

  //   const csvContent = [
  //     csvHeaders.join(","), // Headers
  //     ...csvData.map((row) => row.join(",")), // Data rows
  //   ].join("\n");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.setAttribute("download", "income_report.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleCSVExport = () => {
    const csvHeaders = [
      "S.No",
      "Branch",
      "Type",
      "Date",
      "Description",
      "Person Name",
      "Paid by",
      "Paytype",
      "Amount",
    ];
    const csvData = filteredData.map((item, index) => [
      index + 1,
      item.branch_id.branch_name,
      item.type,
      // formatDatefitching(item.date),
      formatDate(item.date),
      item.description,
      item.person_name,
      item.paid_by,
      item.paytype,
      item.amount,
    ]);

    const csvContent = [
      csvHeaders.join(","), // Headers
      ...csvData.map((row) => row.join(",")), // Data rows
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "Income_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = () => {
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      const worksheet = XLSX.utils.table_to_sheet(tableElement);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Income_Report.xlsx");
    } else {
      console.error(
        "Table with ID 'tableId' not found. Check if the table is rendered in the DOM."
      );
    }
  };

 

  // const handleGeneratePDF = () => {
  //   const tableElement = document.getElementById("tableId");
  //   const tablerowElement = document.getElementById("total_amount");

  //   if (!tableElement || !tablerowElement) {
  //     console.error("Table with ID 'tableId' or 'total_amount' not found");
  //     return;
  //   }

  //   html2canvas(tableElement)
  //     .then((canvas1) => {
  //       const imgData1 = canvas1.toDataURL("image/png");
  //       const imgHeight1 = (canvas1.height * 190) / canvas1.width; // Scale image height

  //       // Capture the second table
  //       html2canvas(tablerowElement).then((canvas2) => {
  //         const imgData2 = canvas2.toDataURL("image/png");
  //         const imgHeight2 = (canvas2.height * 190) / canvas2.width; // Scale image height

  //         // Create a new PDF document
  //         const pdf = new jsPDF();
  //         pdf.setFontSize(26);
  //         pdf.text("Income Report", 20, 20);

  //         // Add first table image
  //         pdf.addImage(imgData1, "PNG", 10, 30, 190, imgHeight1); // Adjusted Y-position for first image

  //         // Add second table image below the first one
  //         pdf.addImage(imgData2, "PNG", 10, 30 + imgHeight1 + 10, 190, imgHeight2); // Adjusted Y-position for second image

  //         // Save the PDF
  //         pdf.save("Income_Report.pdf");
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error generating PDF: ", error);
  //     });
  // };

  const handleGeneratePDF = () => {
    const tableElement = document.getElementById("tableId");
    const totalAmountElement = document.getElementById("total_amount");
  
    if (!tableElement || !totalAmountElement) {
      console.error("Table with ID 'tableId' or 'total_amount' not found");
      return;
    }
  
    html2canvas(tableElement, { scale: 2, useCORS: true }).then((canvas1) => {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;
  
      const imgWidth = 190; // Image width
      let imgHeight1 = (canvas1.height * imgWidth) / canvas1.width; // Maintain aspect ratio
  
      let positionY = 20; // Start position
  
      // 📌 Add Title
      pdf.setFontSize(20);
      pdf.text("Income Report", pageWidth / 2, positionY, { align: "center" });
      positionY += 10;
  
      // 📌 Add Table Image
      if (positionY + imgHeight1 > pageHeight - 20) {
        pdf.addPage();
        positionY = 10;
      }
      pdf.addImage(canvas1.toDataURL("image/jpeg", 0.95), "JPEG", 10, positionY, imgWidth, imgHeight1);
      positionY += imgHeight1 + 10;
  
      // 📌 Capture Total Amount Below the Table
      html2canvas(totalAmountElement, { scale: 2 }).then((canvas2) => {
        const imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
  
        // Ensure proper positioning below table
        if (positionY + imgHeight2 > pageHeight - 20) {
          pdf.addPage();
          positionY = 10;
        }
  
        pdf.addImage(canvas2.toDataURL("image/jpeg", 0.95), "JPEG", 10, positionY, imgWidth, imgHeight2);
        positionY += imgHeight2 + 10;
  
        // 📌 Calculate File Size Before Downloading
        const pdfBlob = pdf.output("blob");
        const fileSizeKB = Math.round(pdfBlob.size / 1024);
        console.log(`Estimated PDF file size: ${fileSizeKB} KB`);
  
        pdf.save("Income_Report.pdf");
      });
    }).catch((error) => {
      console.error("Error generating PDF: ", error);
    });
  };
  
  
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const tableElement = document.getElementById("tableId");
    if (tableElement) {
      printWindow.document.write(`
            <html>
              <head>
                <title>Print Income Table</title>
                <style>
                  table { width: 100%; border-collapse: collapse; }
                  th, td { border: 1px solid #000; padding: 8px; text-align: left; }
                  th { background-color: #f2f2f2; }


                  /* Ensuring row structure remains intact */
                            .row { display: flex; flex-wrap: wrap; margin-top: 10px; }
                            .col-lg-9 { flex: 0 0 75%; max-width: 75%; }
                            .col-lg-3 { flex: 0 0 25%; max-width: 25%; }
                            .col-lg-6 { flex: 0 0 50%; max-width: 50%; text-align: center; font-weight: bold; }
                            
                            /* Page break handling for print */
                            @media print {
                                .row { page-break-inside: avoid; }
                                table { page-break-inside: auto; }
                            }
                                
                </style>
              </head>
              <body>
                <h1>Income Report</h1>
                <div>${tableElement.outerHTML}</div>

              <div class="row">
                <div class="col-lg-9"></div>
                <div class="col-lg-3">
                  <div class="row">
                    <div class="col-lg-6">Total Amount </div>
                    <div class="col-lg-6">${totalamount}.00</div>
                  </div>
                </div>
              </div>

              </body>
            </html>
          `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Table with ID 'tableId' not found");
    }
  };





  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);


  const gettoken = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) { }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);
    const total_previlages = username.modules;
    const new_enquiry = total_previlages.find((item) => item.name == "Income Report")
    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions)
  }








  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };









  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="container-fluid" style={{ backgroundColor: "#E8EFF9" }}>
        <div
          className="card p-2"
          style={{
            marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6 pt-2">
              <h6 style={{color:"#8f0505"}}>

                <b>Income Report</b>
              </h6>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 pt-2">
              <div className="row" id="total_amount">
                <div className="col-lg-3"></div>
                <div className="col-lg-4" style={{ textAlign: 'end', textDecoration: "underline" }}><b>Total Amount</b></div>
                <div className="col-lg-4" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalamount}.00</b></div>
              </div>
            </div>

          </div>
          <hr />
          <div className="row p-2">
            <div className="col-lg-2 col-md-3 col-sm-12 mx-3">
              <input
                type="date"
                value={fromDate}
                onChange={handleFromDateChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-2 col-md-3 col-sm-12">
              <input
                type="date"
                value={toDate}
                onChange={handleToDateChange}
                className="form-control"
              />
            </div>



            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={Branches} // Ensure this matches the state variable for the selected branch
                onChange={(e) => setselectBranch(e.target.value)} // Update the state
                className="form-control"
              >
                <option value="">All Branches</option>
                {branch.map((branchItem) => (
                  <option key={branchItem._id} value={branchItem.branch_id?.branch_name}>
                    {branchItem.branch_name}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="col-lg-2 col-md-3 col-sm-12">
            <select
              value={selectedCourse}
              onChange={handleCourseChange}
              className="form-control"
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.course_name}>
                  {course.course_name}
                </option>
              ))}
            </select>
          </div> */}
            <div className="col-lg-2 col-md-3 col-sm-12">
              <select
                value={selectedStatus}
                onChange={handleStatusChange}
                className="form-control"
              >
                <option value="">Select Type</option>
                {statuses.map((status, index) => (
                  <option key={index} value={status.type}>
                    {status.type}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-lg-1 col-md-2 col-sm-12">
              <button className="btn btn-danger" onClick={handleClearFilters}>
                Clear
              </button>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-3 d-flex align-items-center">
              <p className="mb-0 mr-2">Show </p>
              <select
                value={entriesPerPage}
                onChange={handleEntriesPerPageChange}
                className="form-control mx-2"
                style={{ width: "50px" }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={filteredData.length}>All</option>
              </select>
            </div>

            <div className="col-md-6">
              {previllages.download && (
                <button className="btn btn-secondary2 mx-2" onClick={handleCopy}>
                  Copy
                </button>
              )}

              {previllages.download && (
                <button className="btn btn-success2 mx-2" onClick={handleCSVExport}>
                  CSV
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-excel2 mx-2" onClick={handleExport}>
                  Excel
                </button>
              )}
              {previllages.download && (
                <button className="btn btn-info2 mx-2" onClick={handleGeneratePDF}>
                  PDF
                </button>
              )}

              {previllages.download && (
                <button className="btn btn-warning2 mx-2" onClick={handlePrint}>
                  Print
                </button>
              )}
            </div>

            <div className="col-md-3 d-flex align-items-center">
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control"
              />
            </div>
          </div>
          <table id="tableId" className="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Type</th>
                <th>Date</th>
                <th>Description</th>
                <th>person name</th>
                <th>paid by </th>
                <th>Paytype</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {currentEntries.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1 + (currentPage - 1) * entriesPerPage}</td>
                  {/* <td>{item.branch_id}</td> */}
                  <td>{item.branch_id?.branch_name}</td>
                  <td>{item.type}</td>
                  {/* <td>{new Date(item.date).toLocaleDateString()}</td> */}
                  <td>{formatDate(item.date)}</td>
                  <td>{item.description}</td>
                  <td>{item.person_name}</td>
                  <td>{item.paid_by}</td>
                  <td>{item.paytype}</td>
                  <td>{item.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="row" id="total_amount">
            <div className="col-lg-8"></div>
            <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>Total Amount</b></div>
            {/* <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalincome.totalAmount}.00</b></div> */}
            <div className="col-lg-2" style={{ textAlign: 'end', textDecoration: "underline" }}><b>{totalamount}.00</b></div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-lg-4">
              <div className="dataTables_info" role="status" aria-live="polite">
                Showing {indexOfFirstEntry + 1} to{" "}
                {Math.min(indexOfLastEntry, filtered.length)} of {filtered.length}{" "}
                entries
              </div>
            </div>
            <div className="col-lg-5"></div>
            <div className="row">
              <div className="mt-3 pb-5">
                <div className="row">
                  <div className="col-lg-7 col-sm-12 mt-1">
                    <span className="text-dark">
                      Page {currentPage} of {totalPages}
                    </span>
                  </div>
                  <div className="col-lg-5">
                    <nav>
                      <ul className="pagination justify-content-center">
                        {createPagination()}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IncomeReport;
